import { ReactNode, useState } from 'react'

import Icon from 'components/elements/Icon'

import styles from './tooltip.module.scss'

type Props = {
  children?: ReactNode
  trigger?: React.ReactNode
  className?: string
  style?: React.CSSProperties
}

const Tooltip = ({ children = null, trigger = null, style, className = '' }: Props) => {
  const [hovered, setHovered] = useState(false)

  return (
    <span className={styles.parent} onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)}>
      {trigger ? trigger : <Icon color="grey" name="info circle" />}

      {hovered && (
        <div className={`${styles.tooltip} ${className}`} style={style}>
          {children}
        </div>
      )}
    </span>
  )
}

export default Tooltip
